import { h } from 'preact';
import { Skeleton } from './Skeleton';
import styles from '../sorting/SortDropdown.module.scss';
export function SortDropdownSkeleton() {
    return (h("div", { class: styles.sortDropdown },
        h(Skeleton, { width: "180px", height: "40px", borderRadius: "40px" })));
}
